import { Button } from './button';

/**
 * @deprecated use BX.UI.Button
 */
export class PopupWindowButton extends Button
{
	// No additional functionality, just for compatibility
}
